// Use shared base API for endpoint injection
import { api } from '../middleware/api';

export const streportsApi = api.injectEndpoints({
  endpoints: builder => ({
    getSTPurchaseOrders: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `streports/purchaseorders/${cid}/${fdt}/${tdt}`
    }),
    getSTPurchases: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/purchases/${cid}/${fdt}/${tdt}`
    }),
    getSTPurchasesItemWise: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `streports/purchasesitemwise/${cid}/${fdt}/${tdt}`
    }),
    getSTIndents: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/indents/${cid}/${fdt}/${tdt}`
    }),
    getSTIssues: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/issues/${cid}/${fdt}/${tdt}`
    }),
    getSTIssuesDept: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/issuesdept/${cid}/${fdt}/${tdt}`
    }),
    getSTGates: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/gate/${cid}/${fdt}/${tdt}`
    }),
    getSTStocks: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/stock/${cid}/${fdt}/${tdt}`
    }),
    getSTCounterStocks: builder.query<any, any>({
      query: ({ cid, olid, fdt, tdt }) =>
        `streports/counterstock/${cid}/${olid}/${fdt}/${tdt}`
    })
  }),
  overrideExisting: false
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSTPurchaseOrdersQuery,
  useGetSTPurchasesQuery,
  useGetSTPurchasesItemWiseQuery,
  useGetSTIndentsQuery,
  useGetSTIssuesQuery,
  useGetSTIssuesDeptQuery,
  useGetSTGatesQuery,
  useGetSTStocksQuery,
  useGetSTCounterStocksQuery
} = streportsApi;

